import React from "react";
import { renderPrice } from "../../../Utils/functions";
import SingleSlider from "../../../Components/Sliders/SingleSlider";

const Preview = ({ form }) => {
  const renderContactData = () => {
    switch (form.type) {
      case "personal":
        return (
          <div className="row">
            <div className="col-12 d-flex justify-content-between">
              <div>
                <span>نام و نام خانوادگی :</span>
              </div>
              <div>
                <span>{form?.contacts_data?.fullname || "ثبت نشده است"}</span>
              </div>
            </div>
            <div className="col-12 d-flex justify-content-between">
              <div>
                <span>شماره تماس :</span>
              </div>
              <div>
                <span>{form?.contacts_data?.mobile || "ثبت نشده است"}</span>
              </div>
            </div>
            <div className="col-12 d-flex justify-content-between">
              <div>
                <span>ایمیل :</span>
              </div>
              <div>
                <span>{form?.contacts_data?.email || "ثبت نشده است"}</span>
              </div>
            </div>
          </div>
        );
      case "company":
        return (
          <div className="row">
            <div className="col-12 d-flex justify-content-between">
              <div>
                <span>نام شرکت :</span>
              </div>
              <div>
                <span>{form?.contacts_data?.co_name || "ثبت نشده است"}</span>
              </div>
            </div>
            <div className="col-12 d-flex justify-content-between">
              <div>
                <span>تلفن شرکت :</span>
              </div>
              <div>
                <span>{form?.contacts_data?.co_tell || "ثبت نشده است"}</span>
              </div>
            </div>
            <div className="col-12 d-flex justify-content-between">
              <div>
                <span>شماره موبایل :</span>
              </div>
              <div>
                <span>{form?.contacts_data?.co_mobile || "ثبت نشده است"}</span>
              </div>
            </div>
            <div className="col-12 d-flex justify-content-between">
              <div>
                <span>وبسایت شرکت :</span>
              </div>
              <div>
                <span>{form?.contacts_data?.co_url || "ثبت نشده است"}</span>
              </div>
            </div>
            <div className="col-12 d-flex justify-content-between">
              <div>
                <span> آدرس شرکت :</span>
              </div>
              <div>
                <span>{form?.contacts_data?.co_addres || "ثبت نشده است"}</span>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <div id="single-page">
      <div className="single-product">
        <div className="single-product-content">
          <div className="row">
            <div className="col-lg-5">
              <div className="value-label">
                <h4>نام آگهی :</h4>
                <span>{form.title}</span>
              </div>
              <div className="value-label">
                <h4>شهر : </h4>
                <span>{form.city?.title}</span>
              </div>
              <div className="value-label">
                <h4>دسته بندی : </h4>
                <span>{form.category?.title}</span>
              </div>
              <div className="value-label">
                <h4>قیمت : </h4>
                <span>{renderPrice(form.price)}</span>
              </div>
              <div className="value-label">{renderContactData()}</div>
            </div>
            <div className="col-lg-7">
              <SingleSlider data={form} />
            </div>
          </div>
          <div className="row justify-content-center content-single">
            <div className="col-12">
              <h4>توضیحات:</h4>
            </div>
            <div className="col-lg-10">
              <p>{form?.description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preview;
